document.addEventListener('DOMContentLoaded', () => {
    // Your code here...
});